import axios from "axios";
import { REPORT_AI_BASE_URL } from "../constants/api";
import { toast } from "react-toastify";

const aiAxios = axios.create({
  baseURL: REPORT_AI_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});
const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  if (response.status === 401) {
    toast.error("Unauthorized", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

  return response;
};

const errorHandler = (error) => {
  if (error?.response?.status === 401) {
    //Logout on token invalid
    let redirectUrl = localStorage.getItem('redirectUrl');
    localStorage.clear();
        //  navigate(redirectUrl);
     if(redirectUrl!=null && redirectUrl!==undefined && redirectUrl!=='') {
        window.location.href = redirectUrl;
      }

  // }  else if (error?.response?.status === 403){
  //   toast.error("Not Authorized", {
  //     position: toast.POSITION.TOP_RIGHT,
  //   });
  } else if(error?.response?.status >= 500){
    toast.error("Server error - Please retry after some time", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else if (error?.response?.status === 400) {
    toast.error(error?.response?.data?.message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000
    });
  }
  return Promise.reject(error);
};

aiAxios.interceptors.request.use(
  function (config) {
    var accessToken = '';
    var lsToken = localStorage.getItem("accessToken");
    if(lsToken!=='' && lsToken!=null && lsToken!==undefined) {
      accessToken = localStorage.getItem("accessToken");
    }
    
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
    return requestHandler(config);
  },
  function (error) {
    return Promise.reject(error);
  }
);

aiAxios.interceptors.response.use(
  function (response) {
    return responseHandler(response);
  },
  function (error) {
    return errorHandler(error);
  }
);

export default aiAxios;
